import { PageTheme, genPageTheme, shapes } from '@backstage/theme';
import { rail, teal, text } from './tokens';

/**
 * Page-header treatment. The design system keeps content matt (no gradients),
 * reserving gradients for brand chrome — so headers use a single restrained
 * petrol → teal brand gradient, consistent across every `themeId`.
 */
const colors = [rail.base, teal[700]];

const make = (shape: string): PageTheme =>
  genPageTheme({ colors, shape, options: { fontColor: text.onBrand } });

export const clrslatePageThemes: Record<string, PageTheme> = {
  home: make(shapes.wave),
  documentation: make(shapes.wave2),
  tool: make(shapes.round),
  service: make(shapes.wave),
  website: make(shapes.wave),
  library: make(shapes.wave),
  other: make(shapes.wave),
  app: make(shapes.wave),
  apis: make(shapes.wave),
};
